(function () {
  "use strict";

  /* Kit (ConvertKit) embed: inject the form script into each container,
     mirroring the original React KitEmbed component. */
  document.querySelectorAll(".kit-embed").forEach(function (container) {
    if (container.querySelector("script")) return;
    var script = document.createElement("script");
    script.async = true;
    script.setAttribute("data-uid", "752c60bd47");
    script.src = "https://fistful.kit.com/752c60bd47/index.js";
    container.appendChild(script);
  });

  /* FAQ accordion — single-open, matches the original React behaviour
     (opening one item closes whichever else was open). */
  var faqItems = Array.prototype.slice.call(document.querySelectorAll("[data-faq-item]"));

  function setFaqState(item, open) {
    var button = item.querySelector("[data-faq-trigger]");
    var answer = item.querySelector("[data-faq-answer]");
    var label = item.querySelector("[data-faq-label]");
    var icon = item.querySelector("[data-faq-icon]");
    button.setAttribute("aria-expanded", String(open));
    answer.hidden = !open;
    icon.textContent = open ? "−" : "+";
    label.classList.toggle("f-highlight", open);
  }

  faqItems.forEach(function (item) {
    var button = item.querySelector("[data-faq-trigger]");
    if (!button) return;
    button.addEventListener("click", function () {
      var isOpen = button.getAttribute("aria-expanded") === "true";
      faqItems.forEach(function (other) {
        setFaqState(other, other === item ? !isOpen : false);
      });
    });
  });
})();
